import { render, staticRenderFns } from "./Multiviewer.vue?vue&type=template&id=6c993b2d&scoped=true"
import script from "./Multiviewer.vue?vue&type=script&lang=js"
export * from "./Multiviewer.vue?vue&type=script&lang=js"
import style0 from "./Multiviewer.vue?vue&type=style&index=0&id=6c993b2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c993b2d",
  null
  
)

export default component.exports